import "./scheduleteaser.scss";
import { Link } from "react-router-dom";
import BRschedule from "../../assets/images/RealBRSchedule.jpg";
import Cschedule from "../../assets/images/RealCSchedule.jpg";

// Schedule teaser (backlog #5, 2026-10-23): the full schedules only lived
// on /schedule, which most homepage visitors never reached. This section
// shows the actual schedule images for both locations on the homepage
// and links to the full Schedule page, then routes to the trial.
// Facts only: the site's own schedule images, the two known addresses,
// and the existing phone number — no class times are typed out here,
// so nothing can drift from the posted schedules.
export default function ScheduleTeaser() {
  return (
    <section className="section schedule-teaser-section" id="schedule-teaser">
      <div className="container schedule-teaser-container">
        <p className="schedule-teaser-eyebrow">CLASS SCHEDULE</p>
        <h2 className="schedule-teaser-title">
          Find a Class Time That Fits Your Week
        </h2>
        <p className="schedule-teaser-lead">
          Check the weekly schedule for your location, pick a time that
          works, then book your first class free.
        </p>

        <div className="grid schedule-teaser-grid">
          <div className="schedule-teaser-card">
            <Link to="/schedule" className="schedule-teaser-image-link">
              <img
                loading="lazy"
                src={BRschedule}
                alt="Basking Ridge class schedule"
              />
            </Link>
            <h3>Basking Ridge</h3>
            <p>403 King George Rd, Basking Ridge, NJ 07920</p>
            <Link to="/schedule" className="schedule-teaser-button">
              View Full Schedule
            </Link>
          </div>

          <div className="schedule-teaser-card">
            <Link to="/schedule" className="schedule-teaser-image-link">
              <img
                loading="lazy"
                src={Cschedule}
                alt="Clinton class schedule"
              />
            </Link>
            <h3>Clinton</h3>
            <p>114 W Main St, Clinton, NJ 08809</p>
            <Link to="/schedule" className="schedule-teaser-button">
              View Full Schedule
            </Link>
          </div>
        </div>

        <p className="schedule-teaser-cta-row">
          <Link to="/#trial" className="schedule-teaser-cta">
            Found a Time? Book My FREE Class
          </Link>
        </p>
        <p className="schedule-teaser-alt">
          Questions? <a href="mailto:pskyman1@gmail.com">Email us at pskyman1@gmail.com</a>
        </p>
      </div>
    </section>
  );
}
